module.exports = __webpack_public_path__ + "static/img/wobao.2105028b.png";